import cn from 'classnames';

import { formatBytes } from 'CorePackage/MainModule/common/formatBytes';
import { IconFile } from 'UIPackage/IconsModule/components/IconFile';

import { Progress } from './Progress';
import styles from './UploadFile.module.scss';

export interface IUploadFileProps {
  className?: string;
  fileName: string;
  fileSize: number;
  fileType?: string;
  progress?: number;
  error?: boolean;
  onFileNameClick?: () => void;
  onRemove?: () => void;
}

export const UploadFile = ({
  className,
  fileName,
  fileSize,
  fileType,
  progress,
  error,
  onFileNameClick,
  onRemove,
}: IUploadFileProps) => {
  const classNames = cn(styles.UploadFile, className);

  return (
    <div className={classNames}>
      <div className={styles.InfoBlock}>
        <IconFile margin="right" fileName={fileName} fileType={fileType} />
        <div className={styles.Info}>
          <span className={styles.NameBlock}>
            {onFileNameClick ? (
              <button className={cn(styles.FileName, styles.FileNameLink)} type="button" onClick={onFileNameClick}>
                {fileName}
              </button>
            ) : (
              <span className={styles.FileName}>{fileName}</span>
            )}
            {onRemove && (
              <>
                &nbsp;
                <button className={styles.RemoveButton} type="button" onClick={onRemove}>
                  x
                </button>
              </>
            )}
          </span>
          <span className={styles.FileSize}>{`${formatBytes(fileSize, 0)}`}</span>
        </div>
      </div>
      {!error && (progress || progress === 0) && (
        <div className={styles.Status}>
          <div className={styles.ProgressBarWrap}>
            <Progress percent={progress} isProgressNumberVisible />
          </div>
        </div>
      )}
      {error && <div className={styles.Error}>{error}</div>}
    </div>
  );
};
